import {useDispatch, useSelector} from 'react-redux';
import {IElementQuestionMatchPair} from '../../../../../incase-domain/elements/question/questionMatchPair';
import {useSaveRunfile} from '../../../../../hooks/useSaveRunfile';
import {IGameConfig} from '../../../../../incase-domain/proptypes/gameConfig';
import {QuestionMatchPairInteractions} from '../../../../../incase-domain/proptypes/runfile';
import {getNewPointsMultiple} from '../../../../../service/gamification.service';
import {gameConfigSelector} from '../../../../../store/selectors/presentation.selectors';
import {pointsSelector} from '../../../../../store/selectors/runfile.selectors';
import {checkIfAllPairsAreCorrect, countPairsCorrectness} from '../../../../../util/matchPairs.utils';
import {handleElementsClickedAction} from '../../../../../store/actions/chalkBoardElements.actions';

function useMatchPairTry(): (element: IElementQuestionMatchPair, elementInteractions: QuestionMatchPairInteractions) => void {
    const saveRunfile = useSaveRunfile();

    const points = useSelector(pointsSelector);
    const gameConfig = useSelector(gameConfigSelector);
    const dispatch = useDispatch();

    function handleTry(element: IElementQuestionMatchPair, elementInteractions: QuestionMatchPairInteractions): void {
        const {retryQuestion, noOfAttempts, haveTryButton} = element;
        const {answered, submittedPairs, retriedAnswers} = elementInteractions;
        if (answered) return;
        const allPairsCorrect = checkIfAllPairsAreCorrect(element, submittedPairs || []);
        const isRetry = haveTryButton && retryQuestion && (retriedAnswers?.length || 0) + 1 < (noOfAttempts || 0) && !allPairsCorrect;
        if (isRetry) {
            saveRunfile(
                {
                    ...elementInteractions,
                    retriedAnswers: [...(retriedAnswers || []), submittedPairs],
                    answered: false,
                    submittedPairs: [],
                },
                element.id,
                element.slideId,
                points || 0
            );
        } else {
            const [correctPairsCount, wrongPairsCount] = countPairsCorrectness(element, submittedPairs || []);
            const newPoints = getNewPointsMultiple(
                points || 0,
                correctPairsCount,
                wrongPairsCount,
                gameConfig || ({} as IGameConfig),
                element.gameConfig
            );
            saveRunfile(
                {
                    ...elementInteractions,
                    answered: true,
                },
                element.id,
                element.slideId,
                newPoints
            );

            dispatch(handleElementsClickedAction([element.id], !!element.clearAfterClicked));
        }
    }

    return handleTry;
}

export default useMatchPairTry;
